import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
export var SalesStatus;
(function (SalesStatus) {
    SalesStatus[SalesStatus["NotPayable"] = 0] = "NotPayable";
    SalesStatus[SalesStatus["Payable"] = 1] = "Payable";
})(SalesStatus || (SalesStatus = {}));
export const SalesStatusMap = new Map([
    [SalesStatus.NotPayable, 'Grid.Filter.Option.ShowNotPayable'],
    [SalesStatus.Payable, 'Grid.Filter.Option.ShowPayable'],
]);
let SalesStatusService = class SalesStatusService {
    constructor(_translate) {
        this._translate = _translate;
        this._data = SalesStatusMap;
    }
    list() {
        return this._data;
    }
    get(key) {
        const k = this._data.get(key);
        return k ? this._translate.instant(k) : k;
    }
};
SalesStatusService.ctorParameters = () => [
    { type: TranslateService }
];
SalesStatusService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [TranslateService])
], SalesStatusService);
export { SalesStatusService };
